import { Card } from '@auviknetworks/iceberg-ui';
import { PageHeader } from 'application/Home/Admin/Workato/Components/PageHeader';
import { SessionHelper } from 'application/Shared/Helpers';
import { useSession } from 'hooks/redux/Selectors/session';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ProfileForm } from './ProfileForm';

interface ConfigureSelfUserProps {
    initialSetup: boolean;
}

export const ConfigureSelfUser = ({ initialSetup }: ConfigureSelfUserProps) => {
    const session = useSession();
    const { t } = useTranslation();

    const sessionHelper = new SessionHelper(session);
    const user = sessionHelper.getUser();

    return (
        <>
            <PageHeader title={t('Common.profile')} />
            <Card margin="24px" data-testid="configureSelfUser">
                <ProfileForm initialSetup={initialSetup} user={user} />
            </Card>
        </>
    );
};
